export default class DtoAccessType {
    constructor(obj) {
        this.idStation = obj.idStation // Long,
        this.typeAccess = obj.typeAccess // Option[Long],
        this.nature = obj.nature // Option[Long],
        this.amount = obj.amount // Option[Int],
        this.status = obj.status // Option[Long]
    }
}